
























































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { UpgradeJob, UpgradeJobType } from '@/types/upgradejob';
import { Cycle } from '@/types/cycle';
import { UpgradeReportType, ReportTypeIdUtil } from '@/types/upgradereporttype';
import { upgradeJobTabs } from '@/types/upgradejobtabs';


@Component({
  name: 'ascad-and-tunes-seeding-form',
  props: {
    lastThreeCycles: Array,
    ascadReportHistory: Array,
    tunesReportHistory: Array,
    tunesDebitsReportHistory: Array,
    currentlySelectedFiId: Number,
    jobOnThisTabRunning: Boolean,
  },
})
export default class AscadAndTunesSeedingForm extends Vue {
	UpgradeReportType = UpgradeReportType;

	upgradeJobTabs = upgradeJobTabs;

	SELECT_CYCLE_END_DATE_ABOVE_MSG:string = 'Select Statement Cycle End Date above';

    selectedCycleId:string = '';

	tunesImport:string = 'No';

	cycleMap:Map<string, Cycle> = new Map();

	yesNoOptions:Array<String> = ['Yes', 'No'];

	isJobOnThisTabRunning() {
	  return this.$props.jobOnThisTabRunning;
	}

	@Watch('lastThreeCycles')
	updateCycleData() {
	  this.cycleMap = new Map();
	  this.$props.lastThreeCycles.forEach((cycle:any) => {
	    this.cycleMap.set(cycle.id, cycle);
	  });
	}

	@Watch('selectedCycleId')
	onSelectedCycleEndDate() {
	  this.$emit('statementCycleEndDateSelected',
	  	UpgradeReportType.ASCAD, this.cycleMap.get(this.selectedCycleId)!.statementEndDate);
	  if (this.tunesImport === 'Yes') {
	    this.$emit('statementCycleEndDateSelected',
	      UpgradeReportType.TUNES, this.cycleMap.get(this.selectedCycleId)!.qualificationEndDate);
	    this.$emit('statementCycleEndDateSelected',
	      UpgradeReportType.TUNES_DEBITS, this.cycleMap.get(this.selectedCycleId)!.qualificationEndDate);
	  }
	}

	@Watch('tunesImport')
	onTunesImportChange() {
	  if (this.selectedCycleId.length !== 0) {
	    if (this.tunesImport === 'Yes' && !this.areTunesReportsLoaded()) {
		  this.$emit('statementCycleEndDateSelected',
		  	UpgradeReportType.TUNES, this.cycleMap.get(this.selectedCycleId)!.qualificationEndDate);
		  this.$emit('statementCycleEndDateSelected',
		  	UpgradeReportType.TUNES_DEBITS, this.cycleMap.get(this.selectedCycleId)!.qualificationEndDate);
	    } else {
	      this.$emit('clearReportHistory', UpgradeReportType.TUNES);
	      this.$emit('clearReportHistory', UpgradeReportType.TUNES_DEBITS);
	    }
	  }
	}

	emitRunUpgradeJob() {
	  this.$emit('runSelectedUpgradeJob',
	    UpgradeJobType.ASCAD,
	    '/api/krp/admin/upgrade/ascad',
	    this.getRunReportRequestBody(this.cycleMap.get(this.selectedCycleId)!.statementEndDate),
					this.cycleMap.get(this.selectedCycleId)!.statementEndDate);
	  if (this.tunesImport === 'Yes') {
	    this.$emit('runSelectedUpgradeJob',
	      UpgradeJobType.TUNES,
	      '/api/krp/admin/upgrade/tunes',
	      this.getRunReportRequestBody(this.cycleMap.get(this.selectedCycleId)!.qualificationEndDate),
						this.cycleMap.get(this.selectedCycleId)!.qualificationEndDate);
	  }
	}

	getRunReportRequestBody(coreProcessingDate:string) {
    	return {
	    fiId: this.$props.currentlySelectedFiId,
	    processingDate: coreProcessingDate,
	  };
	}

	areNoReportsForSelectedFi() {
	  return 	this.$props.ascadReportHistory
				&& this.$props.ascadReportHistory.length === 0
				&& this.selectedCycleId.length !== 0;
	}

	areAscadReportsLoaded() {
	  return this.$props.ascadReportHistory
			&& this.$props.ascadReportHistory.length !== 0;
	}

	areTunesReportsLoaded() {
	  return this.$props.tunesReportHistory
			&& this.$props.tunesReportHistory.length !== 0;
	}

	areTunesDebitsReportsLoaded() {
	  return this.$props.tunesDebitsReportHistory
			&& this.$props.tunesDebitsReportHistory.length !== 0;
	}

	shouldDisableRunReportButton() {
	  return this.selectedCycleId.length === 0;
	}

	emitDownloadReport(reportType:UpgradeReportType, s3Key:string, versionId:string) {
	  if (reportType === UpgradeReportType.ASCAD) {
	    this.$emit('downloadPreviousReportVersion', reportType, s3Key, versionId,
			this.cycleMap.get(this.selectedCycleId)!.statementEndDate);
	  } else {
	    this.$emit('downloadPreviousReportVersion', reportType, s3Key, versionId,
			this.cycleMap.get(this.selectedCycleId)!.qualificationEndDate);
	  }
	}
}
